import { get, post } from '../tools/http';
import { copy, comparer } from '../tools/comparer';
import { isoStringToYYYYMMDD } from '../tools/moment-date';

export default {
    state: {
        participationInProjects: [],
        participationInProjectsServer: [],
    },
    mutations: {
        setParticipationInProjects: (state, participationInProjects) => {
            state.participationInProjects = participationInProjects;
            state.participationInProjectsServer = copy(participationInProjects);
        },
        setParticipationInProject: (state, participationInProjects) => {
            state.participationInProjects.push(participationInProjects);
            state.participationInProjectsServer.push(copy(participationInProjects));
        },
        updateParticipationInProject: (state, participationInProject) => {
            let projectFinderIndex = state.participationInProjects.findIndex((project) => {
                return project.id == participationInProject.id;
            });
            if (projectFinderIndex > -1) {
                state.participationInProjects[projectFinderIndex] = {
                    ...state.participationInProjects[projectFinderIndex],
                    ...participationInProject,
                };
                state.participationInProjectsServer[projectFinderIndex] = {
                    ...state.participationInProjectsServer[projectFinderIndex],
                    ...copy(participationInProject),
                };
            }
        },
        removeParticipationInProject: (state, index) => {
            state.participationInProjects.splice(index, 1);
            state.participationInProjectsServer.splice(index, 1);
        },
    },
    actions: {
        loadParticipationInProjects: async (ctx) => {
            let projects = await get('profile', 'project-histories');
            ctx.commit('setParticipationInProjects', projects.histories.map((project)=>{
                return {
                    ...project,
                    dateBegin: isoStringToYYYYMMDD(project['dateBegin']),
                    dateEnd: isoStringToYYYYMMDD(project['dateEnd']),
                };
            }));
        },
        addParticipationInProjects: async (ctx) => {
            const newProject = {
                "userId": ctx.rootGetters.user.id,
                "foreignSeasonId": null,
                "foreignResultId" : null,
                "dateBegin" : null,
                "dateEnd": null,
                "summary": "",
            };
            const postParams = [
                'profile',
                'project-history/create',
                newProject,
                true,
            ];
            let newProjectId = await post(...postParams);
            ctx.commit('setParticipationInProject', {
                ...newProject,
                id: newProjectId.projectHistory.id,
            });
        },
        updateParticipationInProject: async (ctx, {project, index}) => {
            const diff = comparer(ctx.state.participationInProjectsServer[index], project);
            if (Object.keys(diff).length > 0) {
                const postParams = [
                    'profile',
                    'project-history/update',
                    {...diff, id: project.id},
                    true,
                ];
                await post(...postParams);
                ctx.commit('updateParticipationInProject', {...diff, id: project.id});
            }
        },
        removeParticipationInProject: async (ctx, {project, index}) => {
            if (project.id) {
                const getParams = [
                    'profile',
                    `project-history/remove/${project.id}`,
                ];
                await get(...getParams);
            }
            ctx.commit('removeParticipationInProject', index);
        },
    },
    getters: {
        getParticipationInProjects: state => state.participationInProjects,
    },
};